import React from 'react';
import { needs } from '../data/kit';
export function Problem() {
  return <section className="bg-rose-50 py-14 md:py-24 px-4" data-id="element-206" data-mp="2pfif3tqd6arn">
      <div className="max-w-3xl mx-auto" data-id="element-207" data-mp="2peyzijo6rygs">
        <header className="text-center max-w-2xl mx-auto" data-id="element-208" data-mp="2bfprw8e1qcof">
          <h2 className="font-serif font-bold text-wine tracking-tight leading-[1.1] text-[28px] md:text-[46px] [text-wrap:balance]" data-id="element-209" data-mp="2bfg32o4qmbkb">
            NO SE TRATA DE HACER MÁS KEGELS.
          </h2>
          <p className="font-serif font-bold text-rose-600 tracking-tight leading-[1.15] text-[19px] md:text-[28px] mt-3 md:mt-4 [text-wrap:balance]" data-id="element-210" data-mp="21od4bsza68o7">
            SE TRATA DE SABER QUÉ NECESITA TU SUELO PÉLVICO.
          </p>
          <p className="text-ink-muted text-[15px] md:text-lg leading-relaxed mt-5 md:mt-6 max-w-lg mx-auto" data-id="element-211" data-mp="1snev8w9zjayr">
            Si tenés escapes, urgencia o sentís menos control, repetir
            contracciones al azar no siempre es la respuesta.
          </p>
        </header>

        <ul className="grid grid-cols-2 gap-3 md:gap-5 mt-10 md:mt-14" data-id="element-212" data-mp="1npltcffpt34a">
          {needs.map(item => <li key={item.title} className="flex flex-col rounded-2xl bg-white border border-rose-200 overflow-hidden" data-id="element-213" data-mp="t83xfvml7vwy">
              <div className="aspect-[4/3] bg-rose-100 overflow-hidden" data-id="element-214" data-mp="12av7bqztejmh">
                <img src={item.image} alt={item.alt} className="w-full h-full object-cover object-[50%_25%]" loading="lazy" decoding="async" data-id="element-215" data-mp="xbs50eb7yri7" />
              </div>
              <div className="px-3.5 py-4 md:px-6 md:py-6" data-id="element-216" data-mp="5i9kle29q7cp">
                <h3 className="font-serif font-bold text-wine tracking-tight leading-none text-[19px] md:text-[28px]" data-id="element-217" data-mp="jcspbw5opmy6">
                  {item.title}
                </h3>
                <p className="text-ink-muted text-[13px] md:text-base leading-snug md:leading-relaxed mt-2" data-id="element-218" data-mp="3n0kowbrwkjiv">
                  {item.desc}
                </p>
              </div>
            </li>)}
        </ul>

        <div className="text-center max-w-xl mx-auto mt-12 md:mt-16" data-id="element-219" data-mp="1lzee0a3gg1wu">
          <p className="font-serif font-bold text-wine tracking-tight leading-tight text-[22px] md:text-[32px] [text-wrap:balance]" data-id="element-220" data-mp="1qxplie6a20bw">
            POR ESO CREAMOS UN <span className="text-rose-600" data-id="element-221" data-mp="1voxzzomgsbvx">MÉTODO PASO A PASO.</span>
          </p>
          <p className="text-ink-muted text-[15px] md:text-lg leading-relaxed mt-3 md:mt-4" data-id="element-222" data-mp="20mhcaizlqel8">
            Primero entendés qué trabajar. Después aprendés cómo hacerlo. Y
            recién entonces progresás.
          </p>
        </div>
      </div>
    </section>;
}